export enum ImportSource {
	NOTION = 'Notion',
	MIRO = 'Miro',
}
